const aListElementActionsPrimary = {
  aListElementActionsPrimary: {
    tooltipDelete: 'Eliminar',
    tooltipDuplicate: 'Duplicar',
    tooltipEdit: 'Editar'
  }
}

export default aListElementActionsPrimary
